const INFO_LINKS = 'Informácie a odkazy';
const LOCATIONS_HEADING = 'Lokality';
const DIVISION_HEADING = 'Členenie';
const SEARCH_HEADING = 'Vyhľadávanie';
const ADMINISTRATIVE_DIVISION_HEADING = 'Administratívne členenie';
const DIALECTAL_DIVISION_HEADING = 'Nárečové členenie';
const HISTORICAL_DIVISION_HEADING = 'Historické členenie';
const BACKGROUND_HEADING = 'Podklad';
const DOWNLOADING_DATA_MSG = 'Sťahujem dáta...';
const COLOR_SELECTION = 'Výber farby';
const DIALECT_SELECTION = 'Výber nárečia';
const LAYERS_SELECTION = 'Kvíz';
const DOWNLOAD_MAP = 'Stiahnuť mapu';
const COPY_ATTRIBUTION = 'Skopíruj citáciu';
const TEXT_COPIED = 'Text bol úspešne skopírovaný.';
const TEXT_NOT_COPIED = 'Text nebol skopírovaný.';
const DEFAULT = 'Pôvodné';
const OK = 'OK';
const CANCEL = 'Zrušiť';
const LOAD = 'Načítať';
const SAVE = 'Uložiť';
const EXPORT = 'Export';
const ZOOM_IN = 'Priblížiť';
const ZOOM_OUT = 'Oddialiť';

export {
	INFO_LINKS,
	LOCATIONS_HEADING,
	DIVISION_HEADING,
	SEARCH_HEADING,
	ADMINISTRATIVE_DIVISION_HEADING,
	DIALECTAL_DIVISION_HEADING,
	HISTORICAL_DIVISION_HEADING,
	BACKGROUND_HEADING,
	DOWNLOADING_DATA_MSG,
	COLOR_SELECTION,
	DIALECT_SELECTION,
	LAYERS_SELECTION,
	DOWNLOAD_MAP,
	COPY_ATTRIBUTION,
	TEXT_COPIED,
	TEXT_NOT_COPIED,
	DEFAULT,
	OK,
	CANCEL,
	LOAD,
	SAVE,
	EXPORT,
	ZOOM_IN,
	ZOOM_OUT,
};
